var contactFraud = {
    callUs: 'When you call us, we will review all recent activity and confirm the charges made on your account belong to you. If you do not recognize a charge, we will open a claim.',
    contact: 'Contact Us',
    description: 'Please give us a call as soon as possible so we can determine with you whether there was any unauthorized activity.',
    fraudDisclaimer: "<0>$0 Fraud Liability:</0> You're never responsible for unauthorized charges",
    fraudPrevention: 'Fraud Prevention Tips and FAQs',
    title: 'To complete this request, we need to connect you with a representative on our Fraud Solutions Team.'
};
export default contactFraud;
//# sourceMappingURL=contactFraud.js.map